import * as React from 'react';

const SvgIconPencil = ({ width = '24', height = '24', ...props }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask id="mask0_12718_7619" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width={width} height={height} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_12718_7619)">
      <path d="M4.58824 19.4118H5.92394L16.7626 8.57312L15.4269 7.23741L4.58824 18.0761V19.4118ZM3 21V17.4164L16.9664 3.45609C17.1265 3.31068 17.3032 3.19835 17.4966 3.11912C17.6902 3.03971 17.8931 3 18.1054 3C18.3177 3 18.5233 3.03768 18.7222 3.11303C18.9213 3.18838 19.0975 3.30821 19.2508 3.4725L20.5439 4.78174C20.7082 4.93509 20.8253 5.11156 20.8952 5.31115C20.9651 5.51074 21 5.71032 21 5.90991C21 6.12291 20.9636 6.32612 20.8909 6.51953C20.8182 6.71312 20.7026 6.88994 20.5439 7.05L6.58359 21H3ZM16.0831 7.91691L15.4269 7.23741L16.7626 8.57312L16.0831 7.91691Z" fill="black" />
    </g>
  </svg>
);

export default SvgIconPencil;
